import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'rightPad'
})
export class RightPadPipe implements PipeTransform {

  transform(value: any, number: number = 2, character: string = '0' ): any {
    return _.padEnd( value, number, character );
  }
}



// WEBPACK FOOTER //
// ./src/app/right-pad.pipe.ts